// 2026-07-30 (found during a professional-import relevance audit): the whole lead-gen
// engine is WhatsApp-based (wa.me/<phone>), but phone numbers were extracted from
// Google Maps with zero validation that they could even receive WhatsApp. 111/549
// active professionals (20%!) had a non-mobile number on file — mostly landlines
// (02/03/04/08/09, which can NEVER run WhatsApp under any circumstance — no SIM, no
// smartphone OS) or special-service numbers (1700/1800). This is the ONE canonical
// definition of "WhatsApp-capable" — used both here (client-side, gates the
// WaSmartButton "שליחת הודעה" button) and mirrored as a SQL REGEXP in
// lib/waLinks.ts's professional-matching query (can't share a JS function across a SQL
// string, so keep the two patterns in sync by hand if this ever changes).
//
// Mobile (05X) is definite. 07X (VOIP) is left ELIGIBLE, not excluded — many Israeli
// businesses legitimately run WhatsApp Business on a VOIP line, and there's no way to
// tell from the number alone; excluding them would silently hide real, reachable
// professionals. Only the unambiguous cases (traditional landlines, special-service
// numbers) are rejected.
const WHATSAPP_CAPABLE_RE = /^0(5[0-9]|7[0-9])[0-9]{7}$/;

// 2026-07-30 (upgrade — real verification over a format guess): `whatsappValid` is
// he_professionals.whatsapp_valid (1/0/null), populated by the wa-daemon's actual
// onWhatsApp() check (scripts/check-whatsapp-validity.mjs backfill + live at import
// time in app/api/scrape-pros/import/route.ts) — ground truth, not a regex guess.
// - whatsappValid === 0 → definitively confirmed dead, even if the format looks like
//   a normal mobile (a 05X number can still be unregistered/deactivated) — reject.
// - whatsappValid === 1 → definitively confirmed live — accept, regardless of format
//   (covers any edge case the regex itself might misjudge).
// - whatsappValid is null/undefined (not yet checked) → fall back to the format
//   regex, same as before this upgrade; never blocks a professional just for being
//   unverified yet.
/** LAW 04/10/26 (Founder): a pro's phone NEVER reaches the browser — every contact goes through OUR WhatsApp (call AND message).
 *  Server code hands the client this stand-in instead of the number: null = no phone, 'wa-ok' / 'wa-no' = has a phone (WhatsApp-capable or not).
 *  Components keep their "has a phone?" / isWhatsAppCapable() logic; nothing can dial or message the pro from the page. */
export function clientPhone(phone: string | null | undefined, whatsappValid?: number | null): 'wa-ok' | 'wa-no' | null {
  if (!phone) return null;
  return isWhatsAppCapable(phone, whatsappValid) ? 'wa-ok' : 'wa-no';
}
export function isWhatsAppCapable(phone: string | null | undefined, whatsappValid?: number | null): boolean {
  if (phone === 'wa-ok') return whatsappValid !== 0;
  if (phone === 'wa-no') return false;
  if (whatsappValid === 0) return false;
  if (whatsappValid === 1) return true;
  if (!phone) return false;
  const digits = phone.replace(/[\s\-\(\)\+]/g, '');
  return WHATSAPP_CAPABLE_RE.test(digits);
}
